<section class="container w-full flex flex-col">
  <ng-container *ngIf="ui.isLoading">
    <mat-progress-bar [mode]="'indeterminate'"></mat-progress-bar>
  </ng-container>

  <header class="container__header w-full flex flex-row items-center">
    <p class="container__header__title w-full">{{ getDialogDynamicTitle() }} Offer</p>
    <ng-container *ngIf="isEditingOffer">
      <ts-button
        [type]="'icon'"
        [icon]="'delete'"
        [color]="'basic'"
        class="pr-2"
        [matTooltip]="'Delete this offer'"
        [appAuthorize]="canEditDeal()"
        (click)="deleteOffer()"
      ></ts-button>
    </ng-container>
    <ts-button
      [type]="'icon'"
      [icon]="'close'"
      [color]="'basic'"
      [matTooltip]="'Close'"
      (click)="discard()"
    ></ts-button>
  </header>

  <main
    class="container__field-list w-full h-auto overflow-y-auto"
    [ngClass]="{ 'edit-mode': ui.isEditing }"
    cdkDropList
    [cdkDropListData]="currentFields"
    (cdkDropListDropped)="dropped($event)"
    cdkDropListOrientation="vertical"
  >
    <div
      class="container__field-list__item w-full flex flex-row"
      [ngClass]="{ 'pt-3': isPlaceholderField(field) }"
      *ngFor="let field of currentFields; let fieldIndex = index; let isLastField = last"
      cdkDrag
      [cdkDragDisabled]="!ui.isEditing"
    >
      <ng-container *ngIf="ui.isEditing && !isPlaceholderField(field)">
        <div class="container__field-list__item__left flex items-center pr-3">
          <ts-icon cdkDragHandle [icon]="'drag_indicator'" class="cursor-pointer" [matTooltip]="'Drag me'"></ts-icon>
        </div>
      </ng-container>
      <div class="container__field-list__item__center w-full">
        <ng-container [ngSwitch]="field.type">
          <ng-container *ngSwitchCase="'fieldDef'">
            <app-form-field
              [fieldDef]="field.fieldDef"
              [model]="isEditingOffer ? offer : {}"
              [data]="dialogData"
              [readonly]="false"
              [alwaysHideHistory]="true"
              (onUpdate)="onFieldUpdate($event)"
            ></app-form-field>
          </ng-container>
          <ng-container *ngSwitchCase="'placeholder'">
            <mat-form-field>
              <mat-label>Select a field</mat-label>
              <mat-select (selectionChange)="onFieldSelected($event)">
                <mat-option [disabled]="isSelected(field.name)" *ngFor="let field of allowedFields" [value]="field">
                  {{ field?.label }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </ng-container>
        </ng-container>
      </div>
      <div class="container__field-list__item__right flex items-center pr-3">
        <ng-container *ngIf="ui.isEditing">
          <ng-container *ngIf="!field.isRequired || field.isRemovable">
            <ts-button
              [type]="'icon'"
              [icon]="'delete'"
              [color]="'basic'"
              [ngClass]="{ 'px-2': isPlaceholderField(field) }"
              [matTooltip]="isPlaceholderField(field) ? 'Cancel' : 'Remove field'"
              (click)="removeField(fieldIndex)"
            ></ts-button>
          </ng-container>
          <ng-container *ngIf="isPlaceholderField(field)">
            <ts-button
              [type]="'icon'"
              [icon]="'add_circle'"
              [color]="'basic'"
              [disabled]="!selectedFieldDef"
              [matTooltip]="'Add field'"
              (click)="saveField(fieldIndex)"
            ></ts-button>
          </ng-container>
        </ng-container>
      </div>
    </div>

    <article class="mb-4" [ngClass]="{ 'pr-3': ui.isEditing, 'pr-6': !ui.isEditing }">
      <upload-file-table
        [activeOffer]="offer"
        [activeProject]="project"
        (onFileSelected)="onFieldUpdate($event)"
        (onClearFile)="onClearFile()"
      ></upload-file-table>
    </article>
  </main>

  <footer class="container__footer flex justify-between" [ngClass]="{ 'justify-end': !canEditLayout }">
    <ng-container *ngIf="canEditLayout">
      <ng-container *ngIf="ui.isEditing">
        <ts-button
          [type]="'stroked'"
          [icon]="'add'"
          [color]="'basic'"
          [disabled]="ui.isAddingField"
          [matTooltip]="'Add a new field'"
          (click)="addField()"
        >
          New Field
        </ts-button>
      </ng-container>

      <!-- Edit Fields (toggle edit mode on) -->
      <ng-container *ngIf="!ui.isEditing">
        <ts-button [type]="'stroked'" [color]="'basic'" [matTooltip]="'Edit fields'" (click)="toggleEditing()">
          Edit Fields
        </ts-button>
      </ng-container>
    </ng-container>

    <div class="container__footer__actions flex items-center">
      <!-- Cancel Button -->
      <ts-button [type]="'stroked'" [color]="'basic'" (click)="discard()"> Cancel </ts-button>

      <!-- Submit Form Button -->
      <ng-container *ngIf="!ui.isEditing">
        <ts-button [type]="'flat'" [disabled]="isSaveButtonDisabled" [matTooltip]="'Submit'" (click)="submit()">
          Submit
        </ts-button>
      </ng-container>

      <!-- Save Dialog Changes Button (toggle edit mode off) -->
      <ng-container *ngIf="ui.isEditing">
        <ts-button [type]="'flat'" [disabled]="!canSaveTemplate" [matTooltip]="'Save changes'" (click)="saveTemplate()">
          Save
        </ts-button>
      </ng-container>
    </div>
  </footer>
</section>
